/**
 * Strips null/empty branches from a JSON object.
 */
export default (obj) => {
	const _checkJSON = (value) => {
		for (const tempValue of Object.values(value)) {
			if (typeof tempValue === 'object' && tempValue !== null) {
				if (_checkJSON(tempValue)) return true;
			} else if (tempValue !== null) {
				return true;
			}
		}
		return false;
	};

	return JSON.parse(
		JSON.stringify(obj, (key, value) => {
			if (Array.isArray(value)) {
 				return value.filter((item) => item != null);			}
			if (typeof value === 'object' && value !== null && _checkJSON(value)) {
				return value;
			}
			return value ?? undefined;
		})
	);
};
